import * as React from "react";
//import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import FsLightbox from "fslightbox-react";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import ProductTabs from "./ProductTabs";
//import $ from 'jquery';
const GalleryTabGrid = (props) => {
	const [items, setItems] = useState(props.demoData);
    //const [productIndex, setProductIndex] = useState(0);
	//const [filterList] = useState([]);
	useEffect(() => {		  
	   setItems(props.demoData);	  
    }, [props])
	
	function getUnique(array, key) {
		if (typeof key !== 'function') {
			const property = key;
			key = function(item) { return item[property]; };
		}
		return Array.from(array.reduce(function(map, item) {
			const k = key(item);
			if (!map.has(k)) map.set(k, item);
				return map;
			}, new Map()).values());
	}	
	/*const [lightboxController, setLightboxController] = useState({
		toggler: false,
		slide: 1
	 });
	 function openLightboxOnSlide(number) {		
		setLightboxController({
			toggler: !lightboxController.toggler,
			slide: number
		});
	 }*/
	function getCategoryItems(item, category){		
		return (
			(item.category===category)?
			(			 				
				<ProductTabs items={items.filter((item) => item.category === category)} LightBox={FsLightbox} />								
			):null
		)
	 }
	return (
		<>	
		{/*<!-- GALLERY SECTION START --> */}
		
			
				{/*<!-- PAGINATION START --> */}
				
					<Tabs>
						<div className="container">	
							
						
						
							<div className="section-head text-center">
									<h1><span className="site-text-primary">Our</span> Gallery</h1>
									<div className="wt-separator-outer ">
										<div className="wt-separator style-icon">
											<i className="fa fa-leaf text-black"></i>
											<span className="separator-left site-bg-primary"></span>
											<span className="separator-right site-bg-primary"></span>
										</div>                            
									</div>
									<p>Our School Gallery exhibits student creativity and achievements, featuring artwork, photography, music, and projects that reflect our school's culture and values.</p>
							</div>
							<div className="filter-wrap p-a15 our-gallery  m-tb30">
								<TabList className="masonry-filter link-style  text-uppercase center-block m-t0">
										<Tab><span>All</span></Tab>	
										{getUnique(props.demoData, 'category').map((item, index) => (																															
											   <Tab key={index}><span>{item.category}</span></Tab>
										))}	
								</TabList>
						   </div>
						 </div>
						<div className="portfolio-wrap mfp-gallery no-col-gap clearfix">
							<div className="container-fluid">
                 	      		
								 
								
									<TabPanel className="masonry-wrap mfp-gallery  row clearfix d-flex flex-wrap">	
											
										 		<ProductTabs items={props.demoData} LightBox={FsLightbox} />									
									</TabPanel>
									{getUnique(props.demoData, 'category').map((item, index) => (								
										<TabPanel key={item.id} className="masonry-wrap mfp-gallery  row clearfix d-flex flex-wrap">									
												{getCategoryItems(item, item.category)} 								
										</TabPanel>
									))}
								
									
									
								
							 </div>
						</div>	
					</Tabs>
								
			
		
		{/*<!-- GALLERY SECTION END --> */}   
		</>
	);
};
export default GalleryTabGrid;